/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiEmployeesIdQueryResponse,
  GetApiEmployeesIdPathParams,
} from '../models/GetApiEmployeesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiEmployeesIdQueryResponseSchema } from '../zod/getApiEmployeesIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiEmployeesIdQueryKey = (
  id: GetApiEmployeesIdPathParams['id'],
) => [{ url: '/api/employees/:id', params: { id: id } }] as const;

export type GetApiEmployeesIdQueryKey = ReturnType<
  typeof getApiEmployeesIdQueryKey
>;

/**
 * {@link /api/employees/:id}
 */
export async function getApiEmployeesId(
  id: GetApiEmployeesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiEmployeesIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/employees/${id}`,
    ...requestConfig,
  });
  return getApiEmployeesIdQueryResponseSchema.parse(res.data);
}

export function getApiEmployeesIdQueryOptions(
  id: GetApiEmployeesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiEmployeesIdQueryKey(id);
  return queryOptions<
    GetApiEmployeesIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiEmployeesIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiEmployeesId(id, config);
    },
  });
}

/**
 * {@link /api/employees/:id}
 */
export function useGetApiEmployeesId<
  TData = GetApiEmployeesIdQueryResponse,
  TQueryData = GetApiEmployeesIdQueryResponse,
  TQueryKey extends QueryKey = GetApiEmployeesIdQueryKey,
>(
  id: GetApiEmployeesIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiEmployeesIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiEmployeesIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiEmployeesIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
